// DJ Buy X Promo v2 — visual refresh only. Does not alter cart, product form, variants, or ATC state.
(function () {
  if (window.DJBuyXPromoLoaded) return;
  window.DJBuyXPromoLoaded = true;

  var refreshTimer = null;

  function sectionUrl(sectionId) {
    var url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function refreshPromo(promo) {
    if (!promo || promo.dataset.djRefreshing === 'true') return;

    var sectionId = promo.dataset.sectionId;
    var promoId = promo.dataset.djBuyXPromo;
    if (!sectionId || !promoId) return;

    promo.dataset.djRefreshing = 'true';

    fetch(sectionUrl(sectionId), { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var fresh = doc.querySelector('[data-dj-buy-x-promo="' + promoId + '"]');
        if (fresh) promo.replaceWith(fresh);
      })
      .catch(function (error) {
        console.warn('[DJ Buy X Promo] refresh failed', error);
      })
      .finally(function () {
        if (promo && promo.dataset) delete promo.dataset.djRefreshing;
      });
  }

  function refreshAllPromos() {
    document.querySelectorAll('[data-dj-buy-x-promo][data-section-id]').forEach(refreshPromo);
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshAllPromos, delay || 250);
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        scheduleRefresh(180);
      });
    }
  } catch (error) {
    console.warn('[DJ Buy X Promo] pub/sub listener unavailable', error);
  }

  document.addEventListener('cart:updated', function () { scheduleRefresh(180); });

  // Fallback for themes/apps that update cart via fetch without exposing Dawn pub/sub globally.
  if (window.fetch && !window.DJBuyXPromoFetchWrapped) {
    window.DJBuyXPromoFetchWrapped = true;
    var nativeFetch = window.fetch;

    window.fetch = function () {
      var request = arguments[0];
      var requestUrl = '';

      try {
        requestUrl = typeof request === 'string' ? request : request && request.url ? request.url : '';
      } catch (error) {
        requestUrl = '';
      }

      return nativeFetch.apply(this, arguments).then(function (response) {
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(requestUrl)) {
          scheduleRefresh(320);
        }
        return response;
      });
    };
  }
})();